module.exports = __webpack_public_path__ + "static/img/state2.d9ffbebd.png";